import { createActionGroup, props } from '@ngrx/store';
import { UploadResponse, VariableCost } from '@tdf/rtpca-models';

export const variableCostApiActions = createActionGroup({
  source: 'Variable Cost API',
  events: {
    'Load Variable Cost': props<{ refinery: string }>(),
    'Load Variable Cost Failure': props<{ error: string }>(),
    'Load Variable Cost Success': props<{ variableCosts: VariableCost[] }>(),
    'Save Variable Cost': props<{ variableCost: VariableCost; file?: any }>(),
    'Save Variable Cost Success': props<{ variableCost: VariableCost; isVariableCost: UploadResponse, file?: File }>(),
    'Save Variable Cost Failure': props<{ error: string, refinery: string}>(),
    'Set Update': props<{ isUpdate: boolean; id: number }>(),
    'Update Variable Cost': props<{ variableCost: VariableCost; isVariableCost: UploadResponse, file: File, refinery: string}>(),
    'Update Variable Cost Success': props<{ variableCost: VariableCost, refinery: string}>(),
    'Update Variable Cost Failure': props<{ error: string, refinery: string}>(),
    'Update Variable Cost Name': props<{ variableCostId: number; newName: string; refinery: string }>(),
    'Update Variable Cost Name Success': props<{ variableCostId: number, refinery: string}>(),
    'Update Variable Cost Name Failure': props<{ error: string, refinery: string}>(),
    'Delete Variable Cost': props<{ variableCostId: number; refinery: string }>(),
    'Delete Variable Cost Success': props<{ variableCostId: number; refinery: string }>(),
    'Delete Variable Cost Failure': props<{ error: string }>(),
  },
});
